import Vue from 'vue'
import Vuex from 'vuex'
import base from './components/base.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	host:"https://admin.xiaojudai.cn/index/",
	token:false,                //是否登录
  	member_id:1,
	member:{},
  	questions:{                     
          is_up: 0,                 //是否查询上一题0不是，1是
          record_id: 0,             //问卷记录id，第一次请求为0
          member_id:1,             //会员id
          question: {              //请求下一题目数组,第一次请求写空数组
              question_id: 0,       //题目id
              answer_ids: [],       //用户选择的答案id组
              answer: ""            //非选择题答案，非选择题写空字符串
            }
      },
    cartNum:0,
    cartGoodsId:[],
    orderStep:0,
    ballx:0,
    bally:0,
    informShow:true,
  },
  mutations: {
	//检查本地保存的id
	checkMemberId(state,memberid){
	
		let _memberid = base.getCookie("NUTRIPACKS1")

		if(_memberid){
      			state.member_id =_memberid 
			state.token = true
		}else{
			state.token = false
		}
		
	},
	//保存会员信息到本地
	saveMemberId(state,memberid){
		

		base.setcookie("NUTRIPACKS1",memberid)

		
      		state.member_id = memberid 
			state.token = true
		
		
	},
	saveMember(state,member){
		base.setcookie("NUTRIPACKSUSER",member)
	  		state.member = member
	},


  	modifyQuestions(state,n){
          state.questions = n
		  console.log("修改")
  	},
  	seveid(state,m){
  		state.member_id = m
  	},
    saveCartNum(state,i){
      setTimeout(()=>{
            if(i.add){
                state.cartNum = i.cartNum + 1
                state.cartGoodsId.push(i.goodsId)
              }else{
                if(i.cartNum==0)return
                state.cartNum = i.cartNum - 1
                let _i = -1
                state.cartGoodsId.forEach((item,index)=>{
                    if(item == i.goodsId){
                        _i = index
                    }
                })
                if(_i!=-1){
                  state.cartGoodsId.splice(_i,1)
                }
              }
      },600)
      
    },
    saveInform(state,q){
        state.informShow =false
    },
    saveOrderStep(state,j){
      state.orderStep = j
    },
    saveBall(state,xy){
      console.log(xy,$(".cartNumBox")[0].offsetLeft + 100)
      $("#ball").css({ "transition": "all 0.8s","-webkit-transition": "all 0.8s",display:"block"})
      state.ballx = xy.x
      state.bally = xy.y -100
      console.log($(".cartNumBox")) 
      setTimeout(()=>{
         state.ballx = $(".cartNumBox")[0].offsetLeft + 100
         state.bally = 20
         setTimeout(()=>{
             $("#ball").css({ "transition": "","-webkit-transition": "",display:"none"})
         },1000)
      },100)
     // setTimeout(()=>{
     //  state.ballx =( ($(".cartNumBox")[0].offsetLeft + 100) - xy.x)/2+xy.x
     //  state.bally =( ( ($(".cartNumBox")[0].offsetLeft + 100) - xy.x)/2+xy.x)*( ( ($(".cartNumBox")[0].offsetLeft + 100) - xy.x)/2+xy.x)/(-1600000)
     //  setTimeout(()=>{
     //          state.ballx = $(".cartNumBox")[0].offsetLeft + 100
     //          state.bally = 20
     //     setTimeout(()=>{
     //         $("#ball").css({ "transition": "","-webkit-transition": "",display:"none"})
     //     },1000)
     //  },1000)
     // },100)
    }

  },
  actions: {

  }
})
